import { connect } from 'react-redux'

import { actions as LKModalActions } from '../../shared/LKModal'
import { openMenu, closeMenu } from './actions'
import { REDUCER_NAME, hashNames } from './constants'
import {
  generateDropDownParams,
  translateLKMessage,
  translateWebMessage,
  handlePrint,
  generatePrintPDFUrl,
} from './helpers'
import { applicationPrint } from 'src/store/application'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { loanPrint } from 'src/store/loan'
import { printClient } from 'src/store/client'
import { accountPrint } from 'src/store/account'
import { collateralprint, printCollateralManagement } from 'src/store/collateral'
import { printOrder } from 'src/store/accEntry'
import { printLoanCalculator } from 'src/store/loanCalculator'
import { printReporting } from 'src/store/reporting'
import { printCRA } from 'src/store/cra'

const mapStateToProps = (state, { page, chooseFormat }) => {
  const options = state[REDUCER_NAME][page]

  return {
    isOpen: !!options && (chooseFormat || options.length > 1),
    options,
  }
}

enum ApiTypes {
  loan = 'loan',
  loanCollateral = 'loanCollateral',
  client = 'client',
  application = 'application',
  collateral = 'collateral',
  account = 'account',
  entry = 'entry',
  entryConvert = 'entryConvert',
  loanCalculator = 'loancalculator',
  collateralMng = 'collateralmng',
  reporting = 'reporting',
  sdacra = 'sdacra',
}

const apis: Record<ApiTypes, ReturnType<typeof createAsyncThunk>> = {
  [ApiTypes.application]: applicationPrint,
  [ApiTypes.loan]: loanPrint,
  [ApiTypes.loanCollateral]: loanPrint,
  [ApiTypes.client]: printClient,
  [ApiTypes.account]: accountPrint,
  [ApiTypes.collateral]: collateralprint,
  [ApiTypes.entry]: printOrder,
  [ApiTypes.entryConvert]: printOrder,
  [ApiTypes.loanCalculator]: printLoanCalculator,
  [ApiTypes.collateralMng]: printCollateralManagement,
  [ApiTypes.reporting]: printReporting,
  [ApiTypes.sdacra]: printCRA,
}

const mapDispatchToProps = (
  dispatch,
  { type, ID, hash, page, action, direct, defaultrp, extraParams, body, chooseFormat },
) => ({
  handleOpen: (callback) => {
    const params = {
      page,
      action,
      //@ts-ignore
      ...generateDropDownParams(type, { ID, hash }),
    }
    const apiCall = apis[type as ApiTypes]

    dispatch(apiCall(params)).then(async (response) => {
      const Data = response.payload
      if (apiCall.fulfilled.match(response)) {
        let printResult = false
        if (!chooseFormat && (Data.length === 1 || (defaultrp && Data.length > 0))) {
          let report = Data.find((r) => r.DFRP === 1)

          if (!report) report = Data.find((r) => r.DF === 1)

          if (!report) [report] = Data

          try {
            const url = await dispatch(
              generatePrintPDFUrl(type, {
                ID,
                HashSum_PrintReportIDOID_: Data[0].HashSum_PrintReportIDOID_,
                hash,
                PrintReportID: report.ID,
                printReportHash: report[hashNames[type]],
                page: page || action,
                direct,
                extraParams,
                body,
              }),
            )

            if (url) {
              printResult = await handlePrint(url, direct)

              if (!printResult) {
                const urlPDF = await dispatch(
                  generatePrintPDFUrl(type, {
                    ID,
                    hash,
                    PrintReportID: report.ID,
                    printReportHash: report[hashNames[type]],
                    HashSum_PrintReportIDOID_: report.HashSum_PrintReportIDOID_,
                    page: page || action,
                    direct: false,
                    extraParams,
                    body,
                  }),
                )

                handlePrint(urlPDF, false) // View PDF
              }
            }
          } catch (e) {
            if (e && e.Error) {
              dispatch(
                LKModalActions.openError(
                  e.Error.Code === 5
                    ? translateWebMessage('ERR_PRINT_SERVICE_UNAVAILABLE')
                    : e.Error.Message || e.Error.Text || e.Error.Code,
                ),
              )
            }
          }
        }

        const options = Data.map((option) => ({
          value: option.ID,
          key: option.ID,
          text: option.Title,
          dataHash: option[hashNames[type]],
        }))

        dispatch(openMenu(options, page))

        callback()
      } else {
        console.error()
        callback()
      }
    })
  },

  handleOptionChange: async (_event, { value, format, options }, callback) => {
    const printReport = options.find((option) => option.key === value) || {}

    try {
      const url = await dispatch(
        generatePrintPDFUrl(type, {
          ID,
          hash,
          PrintReportID: value,
          printReportHash: printReport.dataHash,
          page: page || action,
          direct,
          format,
          extraParams,
        }),
      )

      if (url) {
        const printResult = await handlePrint(url, direct, format)

        if (!printResult) {
          const urlPDF = await dispatch(
            generatePrintPDFUrl(type, {
              ID,
              hash,
              PrintReportID: value,
              printReportHash: printReport.dataHash,
              page,
              direct: false,
              format,
              extraParams,
            }),
          )
          handlePrint(urlPDF, false, format) // View PDF
        }
      } else {
        dispatch(LKModalActions.openError(translateLKMessage('HINT_ERR_TITLE')))
      }
    } catch (e) {
      if (e && e.Error) {
        dispatch(
          LKModalActions.openError(
            e.Error.Code === 5
              ? translateWebMessage('ERR_PRINT_SERVICE_UNAVAILABLE')
              : e.Error.Message || e.Error.Text || e.Error.Code,
          ),
        )
      }
    } finally {
      callback()
    }
  },

  closeMenu: () => {
    dispatch(closeMenu(page))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
